import { createAsyncThunk } from "@reduxjs/toolkit";
import {
  deleteItemApi,
  getGenericNamesApi,
  getItemApi,
  getItemCategoriesApi,
  getItemGroupsApi,
} from "../../apiservice/accounts";
import {
  getItemCodeApi,
  getItemModelsApi,
  getItemOriginsApi,
  getItemUnitApi,
  getItemRackApi,
  saveItemApi,
  saveItemUploadApi,
  getProductTemplateApi,
  getbranchList,
  getDistributorsApi,
  getManufacturesApi,
  saveDistributorsApi,
  saveManufacturesApi
} from "../../apiservice/inventory";

// Fetch all branches
export const fetchBranchList = createAsyncThunk(
  "itemManage/fetchBranchList",
  async (_, { rejectWithValue }) => {
    try {
      const response = await getbranchList();
      return response?.data?.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

export const fetchItemCode = createAsyncThunk(
  "itemManage/fetchItemCode",
  async (_, { rejectWithValue }) => {
    try {
      const response = await getItemCodeApi();
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

// Fetch all items
export const fetchItemsList = createAsyncThunk(
  "itemManage/fetchItemsList",
  async (_, { rejectWithValue }) => {
    try {
      const response = await getItemApi({ type: "all" });
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

// Fetch item categories
export const fetchItemCategories = createAsyncThunk(
  "itemManage/fetchItemCategories",
  async (_, { rejectWithValue }) => {
    try {
      const response = await getItemCategoriesApi();
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);
export const fetchGenericNames = createAsyncThunk(
  "itemManage/fetchGenericNames",
  async (_, { rejectWithValue }) => {
    try {
      const response = await getGenericNamesApi();
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data || error.message
      );
    }
  }
);
// Fetch item racks
export const fetchItemRacks = createAsyncThunk(
  "itemManage/fetchItemRacks",
  async (_, { rejectWithValue }) => {
    try {
      const response = await getItemRackApi();
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

// Fetch item groups
export const fetchItemGroups = createAsyncThunk(
  "itemManage/fetchItemGroups",
  async (_, { rejectWithValue }) => {
    try {
      const response = await getItemGroupsApi();
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

// Fetch item models
export const fetchItemModels = createAsyncThunk(
  "itemManage/fetchItemModels",
  async (_, { rejectWithValue }) => {
    try {
      const response = await getItemModelsApi();
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

// Fetch item origins
export const fetchItemOrigins = createAsyncThunk(
  "itemManage/fetchItemOrigins",
  async (_, { rejectWithValue }) => {
    try {
      const response = await getItemOriginsApi();
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

// Fetch item units
export const fetchItemUnits = createAsyncThunk(
  "itemManage/fetchItemUnits",
  async (_, { rejectWithValue }) => {
    try {
      const response = await getItemUnitApi({ type: "base_unit" });      
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

// Create or update item
export const createOrUpdateItem = createAsyncThunk(
  "itemManage/createOrUpdateItem",
  async (formData, { rejectWithValue }) => {
    try {
      const response = await saveItemApi(formData);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

// Delete item
export const deleteItem = createAsyncThunk(
  "itemManage/deleteItem",
  async (item_id, { rejectWithValue }) => {
    try {
      const response = await deleteItemApi({ item_id });

      // ✅ Add this check
      if (response.data.error) {
        return rejectWithValue(response.data.msg);
      }

      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

// Import Bulk Items
export const importItems = createAsyncThunk(
  "itemManage/importItems",
  async (itemsData, { rejectWithValue }) => {
    try {
      // ✅ If your backend expects FormData or JSON, adjust this call
      const response = await saveItemUploadApi(itemsData);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

// Fetch item Distributors
export const fetchDistributors = createAsyncThunk(
  "itemManage/fetchDistributors",
  async (_, { rejectWithValue }) => {
    try {
      const response = await getDistributorsApi({ });      
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

export const fetchManufactures = createAsyncThunk(
  "itemManage/fetchManufactures",
  async (_, { rejectWithValue }) => {
    try {
      const response = await getManufacturesApi({});      
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

export const createManufactures = createAsyncThunk(
  "itemManage/createManufactures",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await saveManufacturesApi(payload);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

export const createDistributors = createAsyncThunk(
  "itemManage/createDistributors",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await saveDistributorsApi(payload);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);